// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactNative from "react-native";
import * as Blocks__Utils from "./utils/Blocks__Utils.bs.js";
import * as Blocks__Common from "./common/Blocks__Common.bs.js";
import * as Utils__JsonPlus from "@pageblocks/utils/src/jsonPlus/Utils__JsonPlus.bs.js";
import * as Renderer__Context from "@pageblocks/renderer/src/Renderer__Context.bs.js";
import * as Renderer__Version from "@pageblocks/renderer/src/Renderer__Version.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Renderer__Settings from "@pageblocks/renderer/src/Renderer__Settings.bs.js";
import * as Utils__AllOptionalParser from "@pageblocks/utils/src/Utils__AllOptionalParser.bs.js";
import * as Blocks__SettingsRnAdapter from "./utils/Blocks__SettingsRnAdapter.bs.js";

var blockCode = "input";

function makeStyleFromSettings(settings, context) {
  var match = ReactNative.Platform.OS;
  var tmp = {};
  var tmp$1 = match === "web" ? 0 : undefined;
  if (tmp$1 !== undefined) {
    tmp.minWidth = Caml_option.valFromOption(tmp$1);
  }
  return [
          Blocks__SettingsRnAdapter.Style.flex(settings, context, undefined, undefined),
          Blocks__SettingsRnAdapter.Style.font(settings, context),
          Blocks__SettingsRnAdapter.Style.padding(settings, context),
          Blocks__SettingsRnAdapter.Style.margin(settings, context),
          Blocks__SettingsRnAdapter.Style.border(settings, context),
          Blocks__SettingsRnAdapter.Style.position(settings, context),
          tmp
        ];
}

function Blocks__Input$Component(props) {
  var handleAction = props.handleAction;
  var __context = props.context;
  var context = __context !== undefined ? Caml_option.valFromOption(__context) : Renderer__Context.makeEmpty();
  var settings = Renderer__Settings.deserialize(props.settings);
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var getBool = function (code) {
    return Renderer__Settings.getBool(settings, code, context);
  };
  var onChangeActions = Core__Option.getOr(Core__Option.flatMap(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(props.triggerActions), "onChange"), Blocks__Utils.getActions), []);
  return JsxRuntime.jsx(ReactNative.TextInput, {
              multiline: getBool("multiline"),
              onChangeText: onChangeActions.length !== 0 && handleAction !== undefined ? (function (newValue) {
                    onChangeActions.forEach(function (action) {
                          var id = Core__Option.getOr(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(action), "id"), null);
                          var code = Core__Option.getOr(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(action), "code"), null);
                          var payload = Utils__JsonPlus.addEntries(Core__Option.getOr(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(action), "payload"), null), [[
                                  "value",
                                  newValue
                                ]]);
                          var newAction = Object.fromEntries([
                                [
                                  "id",
                                  id
                                ],
                                [
                                  "code",
                                  code
                                ],
                                [
                                  "payload",
                                  payload
                                ]
                              ]);
                          handleAction(newAction);
                        });
                  }) : undefined,
              placeholder: getString("placeholder"),
              placeholderTextColor: getString("placeholderTextColor"),
              value: getString("text"),
              style: Caml_option.some(makeStyleFromSettings(settings, context)),
              testID: props.testID
            });
}

var Component = {
  make: Blocks__Input$Component
};

var descriptor_meta = {
  version: 1,
  minRendererVersion: Renderer__Version.current
};

var descriptor_declaredTriggers = [{
    code: "onChange",
    name: "On Change"
  }];

var descriptor_declaredSettings = [
  Blocks__Common.paddingSettingGroup,
  Blocks__Common.marginSettingGroup,
  Blocks__Common.borderSettingGroup,
  Blocks__Common.layoutSettingGroup,
  Blocks__Common.inputSettingGroup
];

var descriptor = {
  meta: descriptor_meta,
  code: blockCode,
  component: Component,
  declaredTriggers: descriptor_declaredTriggers,
  declaredSettings: descriptor_declaredSettings
};

var version = 1;

var minRendererVersion = Renderer__Version.current;

export {
  blockCode ,
  version ,
  minRendererVersion ,
  Component ,
  descriptor ,
}
/* react-native Not a pure module */
